<template>
  <header class="mobile-header">
    <div class="top-links">
      <a :href="homeHref" class="nav-link">Home</a>
      <a :href="loginHref" class="nav-link">Already registered? Log in</a>
    </div>

    <div class="brand-stack">
      <img :src="logoSrc" :alt="logoAlt" class="brand-logo brand-logo-clean" />
      <div class="brand-domain brand-domain-centered">{{ domainText }}</div>
    </div>

    <h1>{{ title }}</h1>
    <p v-if="subtitle" class="support-copy">{{ subtitle }}</p>

    <ProgressBar :value="progressValue" :label="progressLabel" />
  </header>
</template>

<script>
import ProgressBar from '@/components/registration/ProgressBar.vue'

export default {
  name: 'FormHeader',
  components: {
    ProgressBar,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: '',
    },
    progressValue: {
      type: Number,
      required: true,
    },
    progressLabel: {
      type: String,
      required: true,
    },
    homeHref: {
      type: String,
      default: '/',
    },
    loginHref: {
      type: String,
      default: '/login',
    },
    logoSrc: {
      type: String,
      default:
        'https://res.cloudinary.com/changa/image/upload/v1776777233/commonshare/transparent-logo.png',
    },
    logoAlt: {
      type: String,
      default: 'M-Changa',
    },
    domainText: {
      type: String,
      default: 'mchanga.africa',
    },
  },
}
</script>

<style scoped>
.mobile-header {
  text-align: center;
}

.top-links {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
  gap: 12px;
}

.nav-link {
  font-size: 12px;
  font-weight: 700;
  color: #445526;
  text-decoration: none;
  line-height: 1.4;
}

.brand-stack {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
}

.brand-logo {
  width: 44px;
  height: 44px;
  object-fit: contain;
  flex-shrink: 0;
}

.brand-logo-clean {
  width: 86px;
  height: 86px;
}

.brand-domain {
  margin-top: 4px;
  font-size: 12px;
  color: #76806f;
}

.brand-domain-centered {
  text-align: center;
}

.mobile-header h1 {
  margin: 18px 0 0;
  font-size: 36px;
  line-height: 1.06;
  color: #38471f;
  font-weight: 700;
}

.support-copy {
  margin: 10px auto 0;
  max-width: 300px;
  font-size: 16px;
  line-height: 1.5;
  color: #67715f;
}
</style>
